import translate from './translate';

export const SUPPORTED_FORMATS = [
  'application/pdf',
  'image/jpeg',
  'image/png',
  'image/tiff',
];

export const faqItems = [
  {
    question: translate('faq.question_1'),
    answer: translate('faq.answer_1'),
  },
  {
    question: translate('faq.question_2'),
    answer: translate('faq.answer_2'),
  },
  {
    question: translate('faq.question_3'),
    answer: translate('faq.answer_3'),
  },
  {
    question: translate('faq.question_4'),
    answer: translate('faq.answer_4'),
  },
  {
    question: translate('faq.question_5'),
    answer: translate('faq.answer_5'),
  },
];

// WITHDRAW
export const WITHDRAW_MIN_ORANGE_DAYS = 10;
export const WITHDRAW_MIN_BROKEN_DAYS = 30;
